import api from './index';

export default {
  index(params) {
    return api({
      method: 'get',
      url: `api/debts`,
      params,
    });
  },
  getById(id, params) {
    return api({
      method: 'get',
      url: `api/debts/${id}`,
      params,
    });
  },
  update(id, data) {
    return api({
      method: 'patch',
      url: `api/debts/${id}`,
      data,
    });
  },
  remainder(id, data) {
    return api({
      method: 'post',
      url: `api/debts/${id}/remainder`,
      data,
    });
  },
};
